function r() {
  return [];
}
export {
  r as default
};
